import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { ic_help } from 'react-icons-kit/md/ic_help';
import LocalStorage from 'utils/LocalStorage';

import Logo from 'static/img/logo.png';
import LogoIGN from 'static/img/logo_ign.png';
import IberpixES from 'static/img/iberpix_es.png';
import IberpixEN from 'static/img/iberpix_en.png';


import './Header.css';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      langSelected: LocalStorage.getString('language') || 'es',
    };
  }

  changeLanguage = (lang) => {
    this.setState({ langSelected: lang }, () => {
      LocalStorage.putString('language', lang);
      window.location.reload();
    });
  }

  navigate = () => {
    window.location.href = '/iberpix';
  }

  openHelp = () => {
    window.open('/iberpix/help', '_blank');
  }

  render() {
    const { langSelected } = this.state;
    const { t } = this.props;

    return (<Fragment>
      <header className='h-desktop' aria-label='Header Iberpix' tabIndex={1}>
        <div className='logo-ign'>
          <img src={LogoIGN} alt='Logo del Ministerio de Transportes, Movilidad y Agenda Urbana'  tabIndex={1}/>
        </div>
        <div className='logo'>
          <a href="https://www.ign.es/web/ign/portal" target='_black' aria-label='Enlace a la web del Instituto Geográfico Nacional' tabIndex={-1}>
            <img src={Logo} alt='Logo del Instituto Geográfico Nacional' tabIndex={1} />
          </a>
        </div>
        <div className='visor-title' onClick={this.navigate}>
          <img src={langSelected === 'es' ? IberpixES : IberpixEN} alt='Logo Iberpix' tabIndex={1}/>
        </div>
        <div className='visor-language' aria-label='Seleccionar idioma o Ayuda' tabIndex={1}>
          <span tabIndex={1} aria-label="Idioma Español" className={langSelected === 'es' ? 'lang-selected' : 'lang-option'} onClick={this.changeLanguage.bind(null, 'es')}>es</span>
          <span tabIndex={1} aria-label="Idioma Ingles" className={langSelected === 'en' ? 'lang-selected' : 'lang-option'} onClick={this.changeLanguage.bind(null, 'en')}>en</span>
          <span tabIndex={1} id="ayudaBoton" title={t('header.help')}>
            <Icon size={'24px'} icon={ic_help} />
          </span>
        </div>
      </header>
    </Fragment>);
  }
}

export default translate()(Header);
